import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Job } from '../../class/job.class';
import { DotStatusComponent } from '../status-dot/status-dot.component';
import { LucideAngularModule } from 'lucide-angular';
import { AsyncPipe, NgClass, NgStyle, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { TimerPipe } from '../../pipes/timer.pipe';
import { ResponsiveService } from '../../services/reponsive.service';
import { Observable } from 'rxjs';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-job-row',
  imports: [DotStatusComponent, LucideAngularModule, NgStyle, AsyncPipe, NgClass, UpperCasePipe, TimerPipe],
  templateUrl: './job-row.component.html',
  styleUrl: './job-row.component.scss',
  animations: [
    trigger('animation', [
      transition(':enter', [
        animate('0.3s', keyframes([
          style({ opacity: 0.2, translate: '-20% 0', offset: 0 }),
          style({ opacity: 1, translate: '0 0', offset: 1 })
        ]))
      ]),
      transition(':leave', [
        animate('0.3s', keyframes([
          style({ opacity: 0.2, translate: '20% 0', offset: 0 }),
          style({ opacity: 1, translate: '0 0', offset: 1 })
        ]))
      ])
    ])
  ],
  host: {
    '[@animation]': ''
  }
})
export class JobRowComponent {
  @Input() job!: Job;
  @Output() onClick: EventEmitter<Job> = new EventEmitter<Job>();
  isDesktop$: Observable<boolean> = this.responsiveService.desktop$;

  constructor(
    private responsiveService: ResponsiveService
  ) { }
}
